Ext.define('SA.data.DataCategories', {
    singleton: true,

    lists: null,

    get({country}) {
        return this.lists.find(list => list.getCountry() === country).getData();
    },

    loadAll() {
        var countries = SA.Institution.getCountries(),
            lists = this.lists = countries.map(country => new SA.data.CountryCategoryList(country.getCode())),
            promises = lists.map(country => country.load());

        return Promise.all(promises);
    }
});